var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.707556 1.21041C0.800069 1.11771 0.909958 1.04416 1.03093 0.99398C1.1519 0.943799 1.28159 0.917969 1.41256 0.917969C1.54352 0.917969 1.67321 0.943799 1.79418 0.99398C1.91515 1.04416 2.02504 1.11771 2.11756 1.21041L6.70756 5.80041C6.80026 5.89293 6.87381 6.00282 6.92399 6.12379C6.97417 6.24476 7 6.37444 7 6.50541C7 6.63638 6.97417 6.76606 6.92399 6.88704C6.87381 7.00801 6.80026 7.1179 6.70756 7.21041L2.11756 11.8004C2.02497 11.893 1.91506 11.9664 1.7941 12.0165C1.67313 12.0666 1.54349 12.0924 1.41256 12.0924C1.28163 12.0924 1.15198 12.0666 1.03101 12.0165C0.910048 11.9664 0.800138 11.893 0.707556 11.8004C0.614974 11.7078 0.541533 11.5979 0.491428 11.477C0.441323 11.356 0.415535 11.2263 0.415535 11.0954C0.415535 10.9645 0.441323 10.8348 0.491428 10.7139C0.541533 10.5929 0.614974 10.483 0.707556 10.3904L4.58756 6.50041L0.707556 2.62041C0.327556 2.23041 0.327556 1.59041 0.707556 1.21041Z",
    fill: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextIcon);
export default __webpack_public_path__ + "static/media/nextIcon.186c8adfbb5fcaf4bffd931636a40cd7.svg";
export { ForwardRef as ReactComponent };